import React from "react"
import { graphql } from "gatsby"

import { PartnerFieldsFragment } from "../../graphql-types"

export const query = graphql`
  fragment PartnerFields on DatoCmsPartner {
    componentId: key
    title
    image {
      url(imgixParams: { w: "600" })
      alt
    }
  }
`

export interface PartnerProps extends PartnerFieldsFragment {
  variant?: "noheader" | "small"
}

const Partners: React.FC<PartnerProps> = props => {
  const title = props.title || ""
  const image = props.image ? props.image : []

  return (
    <section
      id={props.componentId}
      className={`c-partners o-row ${
        props.variant ? `-${props.variant}` : ""
      } `}
    >
      <h2 className="c-content-header">{title}</h2>
      <div className="o-wrapper u-flex u-space-evenly ">
        <div className="c-partners__container">
          {image.map(i => (
            <div className="c-partners__logo-container" key={i.url}>
              <img src={i.url} alt={i.alt || ""} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Partners
